import type { CrmFiche } from "./types";

export type FicheDouble = { fiche: CrmFiche; why: string };

export function ficheDoubles(draft: Pick<CrmFiche, "id" | "kind" | "name" | "email" | "phone" | "siren" | "siret">, others: CrmFiche[]): FicheDouble[] {
  const siret = digits(draft.siret);
  const siren = digits(draft.siren);
  const mail = draft.email.trim().toLowerCase();
  const phone = digits(draft.phone);
  const name = fold(draft.name);
  const hits: FicheDouble[] = [];
  for (const row of others) {
    if (row.id === draft.id) continue;
    const why: string[] = [];
    if (draft.kind !== "particulier" && siret.length === 14 && digits(row.siret) === siret) why.push("même SIRET");
    else if (draft.kind !== "particulier" && siren.length === 9 && digits(row.siren) === siren) why.push("même SIREN");
    if (mail !== "" && row.email.trim().toLowerCase() === mail) why.push("même e-mail");
    if (phone.length >= 8 && digits(row.phone) === phone) why.push("même téléphone");
    if (name.length >= 3 && fold(row.name) === name) why.push("même nom");
    if (why.length > 0) hits.push({ fiche: row, why: why.join(", ") });
  }
  return hits;
}

export function identityLine(fiche: Pick<CrmFiche, "kind" | "siren" | "siret" | "origin" | "owner_name">): string {
  const siret = digits(fiche.siret);
  return [
    fiche.kind === "particulier" ? "Particulier" : "Société",
    fiche.kind !== "particulier" && siret.length === 14 ? `SIRET ${formatSiret(siret)}` : fiche.kind !== "particulier" && digits(fiche.siren).length === 9 ? `SIREN ${digits(fiche.siren)}` : "",
    fiche.origin,
    fiche.owner_name,
  ].filter(Boolean).join(" · ");
}

export function ficheNeedle(row: CrmFiche): string {
  const kind = row.kind === "particulier" ? "particulier" : "société societe";
  const sites = (row.sites || []).flatMap((site) => [site.label, site.address, site.city]);
  const fields = (row.fields || []).flatMap((field) => [field.label, field.value]);
  return [row.name, row.code, row.email, row.phone, row.siren, row.siret, row.origin, row.owner_name, kind, ...(row.tags || []), ...sites, ...fields].join(" ").toLowerCase();
}

function digits(value: string): string {
  return (value || "").replace(/\D/g, "");
}

function formatSiret(digits: string): string {
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)} ${digits.slice(9)}`;
}

function fold(value: string): string {
  return (value || "").normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().replace(/\s+/g, " ").trim();
}
